module.exports = __webpack_public_path__ + "static/img/qr.b854008.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/qr.png
// module id = 726
// module chunks = 1